import React, { FC } from 'react';
import styled from 'styled-components';

import Icon, { IconEnum } from 'components/common/Icon';

const StyledBackToSearchButton = styled.button`
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    height: 42px;
    padding: 6px 12px;
    background: transparent;
    color: var(--color-primary);
    font-weight: var(--font-weight);
    font-size: 15px;
    border: 2px solid var(--color-primary);
    border-radius: 10px;
    transition: background 0.15s ease-in-out, color 0.15s ease-in-out;

    .icon,
    img {
        width: 16px;
        height: 16px;
    }

    &:hover {
        background: var(--color-primary);
        color: var(--color-white);

        .icon,
        img {
            filter: brightness(0) invert(1);
        }
    }
`;

interface BackToSearchButtonProps {
    onClick?: (e: React.MouseEvent) => void;
}

const BackToSearchButton: FC<BackToSearchButtonProps> = ({ onClick }) => <StyledBackToSearchButton type="button" onClick={onClick} aria-label="Wróć do wyszukiwania">
    <Icon icon={IconEnum.ARROW_LEFT} />
    Wróć
</StyledBackToSearchButton>;
export default BackToSearchButton;
